import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminAreaApi as r } from "@maat/api-main";
//#region src/areas/admin/useCreateAreaMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createArea(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreateAreaMutation };
